export default __webpack_public_path__ + "static/media/signature_prison.4f01e7ba.png";